var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGames(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.03955 9.0063C1.03955 4.61762 4.60925 1.04792 8.99793 1.04792C13.3866 1.04792 16.9563 4.61762 16.9563 9.0063C16.9563 13.395 13.3866 16.9647 8.99793 16.9647C4.60925 16.9647 1.03955 13.395 1.03955 9.0063ZM2.0525 8.57934C2.26464 5.09273 5.05687 2.29062 8.53931 2.06287C8.52369 3.77154 7.8339 5.41935 6.6013 6.65198C5.39101 7.87848 3.79116 8.55181 2.0525 8.57934ZM8.22553 15.9221C5.01627 15.566 2.45782 13.0177 2.08605 9.81307C4.14538 9.77834 6.04089 8.97689 7.47667 7.52142C8.93232 6.06574 9.75016 4.11551 9.77285 2.0908C13.0979 2.46099 15.7237 5.18444 15.9417 8.55245C13.8741 8.59259 11.9715 9.39993 10.5292 10.862C9.14103 12.2502 8.32847 14.019 8.22553 15.9221ZM9.47508 15.9485C12.8268 15.7204 15.5352 13.1072 15.9116 9.79752C14.192 9.84555 12.6117 10.5222 11.4116 11.7384C10.2694 12.8806 9.58962 14.3765 9.47508 15.9485Z",
    fill: "#1890FF",
    stroke: "#1890FF",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGames);
export default __webpack_public_path__ + "static/media/games.3d7752dc2f63320227f9043e0fd93f7e.svg";
export { ForwardRef as ReactComponent };